export default RAILS_ASSET_URL("/services_bricks.webp")
